/** IAM list filters — this UI only manages call-center roles, permissions, and users. */
export const CALL_CENTER_IAM_LIST_PARAMS = {
    isCallCenterRelated: 'true',
    isCallCenterUser: 'true',
};
export const CALL_CENTER_IAM_WRITE_FLAGS = {
    isCallCenterRelated: true,
    isCallCenterUser: true,
};
